/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './page-content-header.scss';
import Headline from '../elements/Headline';

class PageContentHeader extends Component {
  // constructor(props) {
  //     super(props);
  // }

  render() {
    const { title, children } = this.props;
    return (
      <div className="bt-page-content-header" id="main-content">
        <div className="bt-page-content-header-title">
          <Headline text={title} />
        </div>
        {children}
      </div>
    );
  }
}

PageContentHeader.propTypes = {
  title: PropTypes.string,
};

PageContentHeader.defaultProps = {
  title: '',
};

export default PageContentHeader;
